import { render } from "./componentTitle.vue?vue&type=template&id=5d42eed1&scoped=true&ts=true"
import script from "./componentTitle.vue?vue&type=script&lang=ts"
export * from "./componentTitle.vue?vue&type=script&lang=ts"

import "./componentTitle.vue?vue&type=style&index=0&id=5d42eed1&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d42eed1"]])

export default __exports__